export const CapabilityList = ({ items, label = "Capacidades" }) => (
  <div data-testid="capability-list">
    <p className="eyebrow mb-6">{label}</p>
    <ul className="grid md:grid-cols-2 gap-x-12">
      {items.map((item, i) => (
        <li key={i} className="flex items-baseline gap-5 border-t border-onix-line py-4">
          <span className="tech-label shrink-0">{String(i + 1).padStart(2, "0")}</span>
          <span className="text-sm md:text-[0.95rem] leading-relaxed text-onix-silver">{item}</span>
        </li>
      ))}
    </ul>
  </div>
);
